import React from 'react'
import Heder from "../Header";
import Menubg from "../../assets/img/Menu button.webp";
import Videoicon from "../../assets/img/videoicon.svg"
import Layer_3 from "../../assets/img/Layer_3.webp"
import Metasoftautomationimg from "../../assets/img/metasoftautomationimg.webp"
import Metasoftiotimg from "../../assets/img/metasoftiotimg.webp"
import Metasoftaiimg from "../../assets/img/metasoftaiimg.webp"
import Footerlogo from "../../assets/img/footerlogo.svg"
import Metasoftmastry from "../../assets/img/metasoftmastry.webp"
import { Link } from 'react-router-dom';
import Topbutton1 from "../../assets/img/top.svg"
import Model from "../model/Model";
function Automation({ activeLink }) {
    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      };
  return (
    <>
    <div className='bg-automation relative'>
<div className='container'>
<Heder textColor="white" />

<div className='flex items-center justify-center'>
    <img src={Videoicon} alt='videoicon' className='absolute top-[25%]'></img>
</div>
<div className="flex justify-end items-center ">
            <img
              src={Menubg}
              alt="menubg"
              data-bs-toggle="modal"
              data-bs-target="#menu"
              className="fixed z-10 bottom-0 cursor-pointer"
            ></img>
          </div>
<div className='flex justify-start items-center'>

    <p className='absolute bottom-5 text-white text-[24px] font-medium lg:w-[481px] md:w-[481px] text-start'>Streamline and optimize Operations </p>
</div>
</div>


    </div>
    <div className='bg-white'>
        <div className='container'>
        <img src={Layer_3} alt='Layer_3' className='mt-[40px]'></img>
        <div>
            <p className='text-black text-[48px] font-semibold capitalize text-start mt-[50px]'>Metasoft Automation</p>
            <div className='flex flex-wrap justify-between mt-[30px]'>
<div>
<p className='text-[#0F0F0F] text-[15px] font-medium lg:w-[511px] text-start '>Metasoft Automation revolutionizes businesses by offering advanced automation solutions that streamline processes and optimize operations. Leveraging cutting-edge technologies such as artificial intelligence (AI) and robotic process automation (RPA), Metasoft Automation helps businesses enhance efficiency, reduce costs, and improve accuracy. From automating repetitive tasks to orchestrating complex workflows, Metasoft Automation empowers organizations to focus on higher-value activities, drive productivity, and achieve business goals with precision and speed. Embrac the future of automation with Metasoft and unlock a new era of operational excellence</p>
</div>
<div>
<p className='text-[#0F0F0F] text-[15px] lg:mt-0 mt-[40px] font-medium lg:w-[511px] text-start'>  Advanced automation solutions by Metasoft Automation
 Leveraging artificial intelligence (Al) and robotic process automation (PA)
 Streamlining and optimizing business operations
 Enhancing efficiency and reducing costs through automation
 Automating repetitive tasks for improved productivity
 Orchestrating complex workflows with precision and speed
 Allowing businesses to focus on higher-value activities
 Increasing accuracy and minimizing human error
 Embracing the future of automation for operational excellence
 Transforming business processes with cutting-edge technology.</p>
</div>
<div>

</div>
            </div>
</div>
<div className='lg:mt-[130px] mt-[70px]'>
    <p className='text-black text-center text-[40px] font-semibold'>More Services</p>
    <div className='flex  flex-wrap justify-between mt-[80px]'>

<div className='relative lg:mt-0 mt-5'>
<img src={Metasoftiotimg} alt='Metasoftautomationimg'></img>
    <p className=' absolute bottom-5 left-5 text-white text-[20px] font-medium '>Metasoft IOT</p>

</div>
<div className='relative lg:mt-0 mt-5'>
<img src={Metasoftaiimg} alt='Metasoftautomationimg'></img>
    <p className=' absolute bottom-5 left-5 text-white text-[20px] font-medium '>Metasoft AI</p>

</div>
<div className='relative lg:mt-0 mt-5'>
<img src={Metasoftmastry} alt='Metasoftautomationimg'></img>
    <p className=' absolute bottom-5 left-5 text-white text-[20px] font-medium '>Metasoft metaverse mastery</p>

</div>
    </div>
</div>
        </div>
    </div>
    <div className='bg-black lg:mt-[150px] mt-[80px]'>
<div className='container'>
<div className="">
<div className='flex justify-between items-center lg:mt-[30px] md:mt-0 mt-[30px]'>
<img src={Footerlogo} alt='footerlogo'></img>
<div className="flex justify-end items-end ">
          {/* <Link to="" target="_blank" className="chatWithUs">
            <img src={Bannerlogo} alt="logobanner"></img>
          </Link> */}

          <button className="myBtn1">
            <Link onClick={scrollToTop}>
              <img alt="" src={Topbutton1} />
            </Link>
          </button>
        </div>
</div>
<div className='lg:flex justify-between  mt-[40px]'>
    <div className='flex lg:gap-[50px] md:gap-[50px] gap-[30px] lg:justify-between md:justify-center hustify-between'>
    <div className='border-solid border-[#D9D9D9] border-r-2 lg:pr-3 md:pr-3 pr-3 lg:h-[120px]'>
        <h5 className='text-[#FFF] text-[14px] font-semibold text-start '>Head Office</h5>
        <p className='text-[#FFF] font-extralight mt-3 text-[14px] w-[165px] text-start leading-6'>Office No. 216A, PO Box No. 90071, Ittihad Square, Al Ittihad Road , Dubai, UAE</p>
    </div>
    <div className=''>
        <h5 className='text-[#FFF] text-[14px] font-semibold text-start'>Branch</h5>
        <p className='text-[#FFF] font-extralight mt-3 text-[14px] w-[165px] text-start leading-6'>Door No.13-I-T/14, 3rd floor - Excel Mall, K.S.Rao Road, Hampankatta, Mangaluru, Karnataka 575001</p>
    </div></div>
    <div className='flex justify-between lg:justify-between md:justify-center lg:gap-[50px] md:gap-[120px] gap-[20px] lg:mt-0 md:mt-5 mt-[30px]'>
    <div className=''>
        <h5 className='text-[#FFF] text-[14px] font-semibold text-start'>Important Links</h5>
        <Link to="/ourservices" className='no-underline'>  <p className='text-[#FFF] font-extralight mt-3 text-[14px]  text-start'>Our Service</p></Link>
      <Link to="/about"  className='no-underline'> <p className='text-[#FFF] font-extralight mt-3 text-[14px]  text-start'>About Us</p></Link>
      <Link to="contact"  className='no-underline' ><p className='text-[#FFF] font-extralight mt-3 text-[14px]  text-start'>Contact</p></Link>
    <Link to="/ourbrands"  className='no-underline'>  <p className='text-[#FFF] font-extralight mt-3 text-[14px]  text-start'>Our Brands</p></Link>
    </div>
    <div className=''>
       
        <h5 className='text-[#FFF] text-[14px] font-semibold text-start'>Mail </h5>
        <p className='text-[#FFF] font-extralight mt-3 text-[14px]  text-start'>Admin@metasoft.ae</p>
     
     
      <h5 className='text-[#FFF] text-[14px] font-semibold mt-2 text-start'>Call </h5>
        <p className='text-[#FFF] font-extralight mt-3 text-[14px]  text-start'>Tel: +971 43 99 1704</p>
        <p className='text-[#FFF] font-extralight mt-3 text-[14px]  text-start'>Mob: +971 56 1163 704</p>
   
    </div>
    </div>
    <div className='lg:mt-0 md:mt-0 mt-[30px]'>
        <h5 className='text-[#FFF] text-[14px] font-semibold text-center '>Follow Us On</h5>
        <div className='flex justify-between gap-4 items-center pt-3'>
      
      <Link to="https://www.facebook.com/metasoftitsolutions" className='no-underline' target="_blank" >      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M30.25 16.5C30.25 8.91 24.09 2.75 16.5 2.75C8.91 2.75 2.75 8.91 2.75 16.5C2.75 23.155 7.48 28.6962 13.75 29.975V20.625H11V16.5H13.75V13.0625C13.75 10.4088 15.9088 8.25 18.5625 8.25H22V12.375H19.25C18.4937 12.375 17.875 12.9937 17.875 13.75V16.5H22V20.625H17.875V30.1813C24.8188 29.4938 30.25 23.6362 30.25 16.5Z" fill="white"/>
  </svg></Link>
  <Link to="https://www.instagram.com/metasoft_it/" className='no-underline' target="_blank" >
  <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.9135 2.75169C18.9169 2.74784 19.9203 2.75793 20.9234 2.78194L21.1901 2.79157C21.4981 2.80257 21.802 2.81632 22.1691 2.83282C23.6321 2.90157 24.6304 3.13257 25.5063 3.47219C26.4137 3.82144 27.1783 4.29444 27.9428 5.05894C28.6418 5.7459 29.1828 6.57687 29.5281 7.49407C29.8678 8.36994 30.0988 9.36957 30.1675 10.8326C30.184 11.1983 30.1978 11.5036 30.2087 11.8116L30.217 12.0783C30.2414 13.081 30.252 14.0839 30.2486 15.0868L30.25 16.1126V17.9138C30.2534 18.9172 30.2428 19.9206 30.2184 20.9237L30.2101 21.1904C30.1991 21.4984 30.1854 21.8023 30.1689 22.1694C30.1001 23.6324 29.8664 24.6307 29.5281 25.5066C29.1839 26.4247 28.6428 27.2564 27.9428 27.9431C27.2552 28.642 26.4238 29.183 25.5063 29.5284C24.6304 29.8681 23.6321 30.0991 22.1691 30.1678C21.802 30.1843 21.4981 30.1981 21.1901 30.2091L20.9234 30.2173C19.9203 30.2418 18.9169 30.2523 17.9135 30.2489L16.8877 30.2503H15.0879C14.0845 30.2537 13.0811 30.2432 12.078 30.2187L11.8112 30.2104C11.4848 30.1986 11.1585 30.1849 10.8322 30.1692C9.36925 30.1004 8.371 29.8667 7.49375 29.5284C6.57619 29.1838 5.74508 28.6427 5.05862 27.9431C4.35881 27.256 3.81731 26.4245 3.47188 25.5066C3.13225 24.6307 2.90125 23.6324 2.8325 22.1694C2.81719 21.8432 2.80344 21.5168 2.79125 21.1904L2.78438 20.9237C2.75902 19.9206 2.74757 18.9172 2.75 17.9138V15.0868C2.74616 14.0839 2.75625 13.081 2.78025 12.0783L2.78987 11.8116C2.80087 11.5036 2.81462 11.1983 2.83112 10.8326C2.89987 9.36819 3.13087 8.37132 3.4705 7.49407C3.81614 6.57642 4.3587 5.74568 5.06 5.06032C5.74598 4.3601 6.57657 3.8181 7.49375 3.47219C8.371 3.13257 9.36787 2.90157 10.8322 2.83282L11.8112 2.79157L12.078 2.78469C13.0806 2.75935 14.0836 2.7479 15.0865 2.75032L17.9135 2.75169ZM16.5 9.62669C15.5891 9.61381 14.6847 9.7821 13.8393 10.1218C12.994 10.4615 12.2246 10.9658 11.5759 11.6054C10.9272 12.245 10.4121 13.0072 10.0604 13.8476C9.70884 14.6881 9.52778 15.59 9.52778 16.501C9.52778 17.412 9.70884 18.314 10.0604 19.1544C10.4121 19.9948 10.9272 20.757 11.5759 21.3966C12.2246 22.0362 12.994 22.5405 13.8393 22.8802C14.6847 23.2199 15.5891 23.3882 16.5 23.3753C18.3234 23.3753 20.072 22.651 21.3614 21.3617C22.6507 20.0724 23.375 18.3237 23.375 16.5003C23.375 14.677 22.6507 12.9283 21.3614 11.639C20.072 10.3496 18.3234 9.62669 16.5 9.62669ZM16.5 12.3767C17.0479 12.3666 17.5924 12.4658 18.1016 12.6685C18.6108 12.8712 19.0745 13.1733 19.4656 13.5572C19.8567 13.9411 20.1674 14.3991 20.3795 14.9044C20.5916 15.4097 20.7009 15.9523 20.701 16.5003C20.7011 17.0483 20.592 17.5909 20.38 18.0963C20.1681 18.6017 19.8575 19.0598 19.4666 19.4438C19.0756 19.8279 18.612 20.1301 18.1029 20.333C17.5938 20.5359 17.0493 20.6352 16.5014 20.6253C15.4074 20.6253 14.3581 20.1907 13.5846 19.4171C12.811 18.6435 12.3764 17.5943 12.3764 16.5003C12.3764 15.4063 12.811 14.3571 13.5846 13.5835C14.3581 12.8099 15.4074 12.3753 16.5014 12.3753L16.5 12.3767ZM23.7188 7.56419C23.2752 7.58195 22.8557 7.77065 22.5481 8.09078C22.2405 8.41091 22.0687 8.83763 22.0687 9.28157C22.0687 9.72551 22.2405 10.1522 22.5481 10.4724C22.8557 10.7925 23.2752 10.9812 23.7188 10.9989C24.1746 10.9989 24.6118 10.8179 24.9341 10.4955C25.2564 10.1732 25.4375 9.73603 25.4375 9.28019C25.4375 8.82435 25.2564 8.38718 24.9341 8.06485C24.6118 7.74252 24.1746 7.56144 23.7188 7.56144V7.56419Z" fill="white"/>
  </svg>
  </Link>
  
  <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M25.0319 3.09375H29.5804L19.6432 14.4513L31.3335 29.9062H22.1787L15.0095 20.5329L6.80625 29.9062H2.255L12.8837 17.7581L1.67062 3.09375H11.055L17.5354 11.6614L25.0291 3.09375H25.0319ZM23.4355 27.1838H25.9559L9.68687 5.67325H6.98225L23.4355 27.1838Z" fill="white"/>
  </svg>
  <Link to="https://www.linkedin.com/company/31008439/admin/feed/posts/" className='no-underline' target="_blank" >
  <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M26.125 4.125C26.8543 4.125 27.5538 4.41473 28.0695 4.93046C28.5853 5.44618 28.875 6.14565 28.875 6.875V26.125C28.875 26.8543 28.5853 27.5538 28.0695 28.0695C27.5538 28.5853 26.8543 28.875 26.125 28.875H6.875C6.14565 28.875 5.44618 28.5853 4.93046 28.0695C4.41473 27.5538 4.125 26.8543 4.125 26.125V6.875C4.125 6.14565 4.41473 5.44618 4.93046 4.93046C5.44618 4.41473 6.14565 4.125 6.875 4.125H26.125ZM25.4375 25.4375V18.15C25.4375 16.9612 24.9652 15.821 24.1246 14.9804C23.284 14.1398 22.1438 13.6675 20.955 13.6675C19.7863 13.6675 18.425 14.3825 17.765 15.455V13.9288H13.9288V25.4375H17.765V18.6587C17.765 17.6 18.6175 16.7338 19.6763 16.7338C20.1868 16.7338 20.6764 16.9366 21.0374 17.2976C21.3984 17.6586 21.6012 18.1482 21.6012 18.6587V25.4375H25.4375ZM9.46 11.77C10.0727 11.77 10.6602 11.5266 11.0934 11.0934C11.5266 10.6602 11.77 10.0727 11.77 9.46C11.77 8.18125 10.7387 7.13625 9.46 7.13625C8.8437 7.13625 8.25265 7.38107 7.81686 7.81686C7.38107 8.25265 7.13625 8.8437 7.13625 9.46C7.13625 10.7387 8.18125 11.77 9.46 11.77ZM11.3713 25.4375V13.9288H7.5625V25.4375H11.3713Z" fill="white"/>
  </svg>
  </Link>
  
  </div>
    </div>
</div>
<div className='flex justify-between mt-[10px] pb-[60px]'>
    <p className='text-[#C6C6C6] text-[10px] font-medium'> Copyright © 2024 metasoft. All Rights Reserved. </p>
    <div className='flex gap-5 items-centet'>
    <p className='text-[#C6C6C6] text-[10px] font-medium'>Terms of use  |   Privacy Environmental Policy</p>
    
    </div>
</div>
        </div>
     </div>
    </div>
    <Model activeLink={activeLink} />
    </>
  )
}

export default Automation